import { selectors as authSelectors } from 'store/features/auth';
import { useSelector } from 'react-redux';

export const useUserPermissions = () => {
  const userPermissions = useSelector(authSelectors.permissions);

  return userPermissions;
};
